<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Perfis e Permissões
          <b-button size="sm" class="float-right m-1" @click="abrirModalAdicionarPermissao">
            <font-awesome-icon icon="plus" class="mr-2" />
            Nova Permissão
          </b-button>
          <b-button size="sm" class="float-right m-1" @click="abrirModalAdicionarPerfil">
            <font-awesome-icon icon="plus" class="mr-2" />
            Novo Perfil
          </b-button>
        </h6>
      </template>
      <b-tabs card>
        <b-tab title="Perfis">
          <div id="tabPerfis">
            <b-row class="up-data">
              <b-col cols="8" class=""></b-col>
              <b-col cols="4" class="">
                <b-input-group size="md">
                  <b-form-input
                    id="filterPerfis-input"
                    v-model="filterPerfis"
                    type="search"
                    placeholder="Pesquisar"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filterPerfis" @click="filterPerfis = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-table :busy="tableBusy" :fields="fieldsPerfis" hover no-border-collapse :items="itemsPerfis" sort-by="" :sort-desc="true"
              striped stacked="sm" per-page="10" :current-page="currentPagePerfis" show-empty small :filter="filterPerfis" :filter-included-fields="filterPerfisOn">
              <template #empty>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="actions-icons">
                  <b-link class="text-dark" @click="abrirModalEdicaoPerfil(row.item.Id)">
                    <font-awesome-icon icon="edit" />
                    <div style="font-size: 12px">Editar</div>
                  </b-link>
                  <btn-excluir :idItem="row.item.Id" :excluirItem="removerPerfil" />
                </div>
              </template>
            </b-table>
            <b-pagination v-model="currentPagePerfis" :total-rows="itemsPerfis.length" per-page="10" aria-controls="my-table" />
          </div>
        </b-tab>
        <b-tab title="Permissões">
          <div id="tabPermissoes">
            <b-row class="up-data">
              <b-col cols="8" class=""></b-col>
              <b-col cols="4" class="">
                <b-input-group size="md">
                  <b-form-input
                    id="filterPermissoes-input"
                    v-model="filterPermissoes"
                    type="search"
                    placeholder="Pesquisar"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filterPermissoes" @click="filterPermissoes = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-table :busy="tableBusy" :fields="fieldsPermissoes" hover no-border-collapse :items="itemsPermissoes" sort-by="" :sort-desc="true"
              striped stacked="sm" per-page="10" :current-page="currentPagePermissoes" show-empty small :filter="filterPermissoes" :filter-included-fields="filterPermissoesOn">
              <template #empty>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="actions-icons">
                  <b-link class="text-dark" @click="abrirModalEdicaoPermissao(row.item.Id)">
                    <font-awesome-icon icon="edit" />
                    <div style="font-size: 12px">Editar</div>
                  </b-link>
                  <b-link class="text-dark" @click="inativarRota(row.item.Id)">
                    <font-awesome-icon :icon="row.item.Rota.includes('--inativo') ? 'check' : 'times'" />
                    <div style="font-size: 12px">{{row.item.Rota.includes('--inativo') ? 'Reativar' : 'Inativar'}}</div>
                  </b-link>
                  <btn-excluir :idItem="row.item.Id" :excluirItem="removerPermissao" />
                </div>
              </template>
            </b-table>
            <b-pagination v-model="currentPagePermissoes" :total-rows="itemsPermissoes.length" per-page="10" aria-controls="my-table" />
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal id="edit-permissao-modal" size="lg" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc
      hide-footer>
      <template v-slot:modal-header="">
        <h5>Editar Permissão</h5>
      </template>
      <b-form @submit.stop.prevent="editarPermissao">
        <b-row>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-caminho" label="Caminho" label-for="input-caminho" label-class="text-left">
              <b-form-input id="input-caminho" v-model="permissaoEditar.Caminho" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-rota" label="Rota" label-for="input-rota" label-class="text-left">
              <b-form-input id="input-rota" v-model="permissaoEditar.Rota" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-perfil" label="Perfil" label-for="input-perfil"
              label-class="text-left">
              <b-form-select id="input-perfil" v-model="permissaoEditar.IdPerfil" :options="perfis"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-apenasUg" label="Apenas UG" label-for="input-apenasUg"
              label-class="text-left">
              <b-form-select id="input-apenasUg" v-model="permissaoEditar.ApenasUg" :options="[{text: 'Sim', value: true}, {text: 'Não', value: false}]"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="pt-4 d-flex justify-content-end">
            <b-button size="sm" class="mr-3" type="submit">
              Salvar Alterações
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="fecharModalEdicaoPermissao()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal id="add-permissao-modal" size="lg" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc
      hide-footer>
      <template v-slot:modal-header="">
        <h5>Criar nova permissão</h5>
      </template>
      <b-form @submit.stop.prevent="adicionarPermissao">
        <b-row>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-caminho" label="Caminho" label-for="input-caminho" label-class="text-left">
              <b-form-input id="input-caminho" v-model="novaPermissao.Caminho" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-rota" label="Rota" label-for="input-rota" label-class="text-left">
              <b-form-input id="input-rota" v-model="novaPermissao.Rota" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-perfil" label="Perfil" label-for="input-perfil"
              label-class="text-left">
              <b-form-select id="input-perfil" v-model="novaPermissao.IdPerfil" :options="perfis"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-apenasUg" label="Apenas UG" label-for="input-apenasUg"
              label-class="text-left">
              <b-form-select id="input-apenasUg" v-model="novaPermissao.ApenasUg" :options="[{text: 'Sim', value: true}, {text: 'Não', value: false}]"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="pt-4 d-flex justify-content-end">
            <b-button size="sm" class="mr-3" type="submit">
              Salvar
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="fecharModalAdicionarPermissao()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal id="edit-perfil-modal" size="lg" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc
      hide-footer>
      <template v-slot:modal-header="">
        <h5>Editar Perfil</h5>
      </template>
      <b-form @submit.stop.prevent="editarPerfil">
        <b-row>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-sigla" label="Sigla" label-for="input-sigla" label-class="text-left">
              <b-form-input id="input-sigla" v-model="perfilEditar.Sigla" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-descricao" label="Descrição" label-for="input-descricao" label-class="text-left">
              <b-form-input id="input-descricao" v-model="perfilEditar.Descricao" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-oculto" label="Oculto" label-for="input-oculto"
              label-class="text-left">
              <b-form-select id="input-oculto" v-model="perfilEditar.Oculto" :options="[{text: 'Sim', value: 'S'}, {text: 'Não', value: 'N'}]"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-controleInterno" label="Controle Interno" label-for="input-controleInterno"
              label-class="text-left">
              <b-form-select id="input-controleInterno" v-model="perfilEditar.ControleInterno" :options="[{text: 'Sim', value: 'S'}, {text: 'Não', value: 'N'}]"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="pt-4 d-flex justify-content-end">
            <b-button size="sm" class="mr-3" type="submit">
              Salvar Alterações
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="fecharModalEdicaoPerfil()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal id="add-perfil-modal" size="lg" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc
      hide-footer>
      <template v-slot:modal-header="">
        <h5>Criar novo Perfil</h5>
      </template>
      <b-form @submit.stop.prevent="adicionarPerfil">
        <b-row>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-sigla" label="Sigla" label-for="input-sigla" label-class="text-left">
              <b-form-input id="input-sigla" v-model="novoPerfil.Sigla" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-descricao" label="Descrição" label-for="input-descricao" label-class="text-left">
              <b-form-input id="input-descricao" v-model="novoPerfil.Descricao" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-oculto" label="Oculto" label-for="input-oculto"
              label-class="text-left">
              <b-form-select id="input-oculto" v-model="novoPerfil.Oculto" :options="[{text: 'Sim', value: 'S'}, {text: 'Não', value: 'N'}]"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-controleInterno" label="Controle Interno" label-for="input-controleInterno"
              label-class="text-left">
              <b-form-select id="input-controleInterno" v-model="novoPerfil.ControleInterno" :options="[{text: 'Sim', value: 'S'}, {text: 'Não', value: 'N'}]"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="pt-4 d-flex justify-content-end">
            <b-button size="sm" class="mr-3" type="submit">
              Salvar
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="fecharModalAdicionarPerfil()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal> 
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import { store } from "@/store"
import permissoesService from '@/services/administracao/permissoesService'
import perfisService from '@/services/administracao/perfisService'

import {fieldsPermissoes} from '@/types/administracao/cadastro-permissoes/fields-permissoes'
import {fieldsPerfis} from '@/types/administracao/cadastro-permissoes/fields-perfis'
import { TableField } from '@/types/table-field'
import { Permissao } from '@/types/administracao/cadastro-permissoes/permissao'
import { Perfil } from '@/types/administracao/cadastro-permissoes/perfil'

const CompProps = Vue.extend({
  name: 'ConsultarPermissoes',
  components: { BtnExcluir },
})

@Component
export default class ConsultarPermissoes extends CompProps {
  currentPagePermissoes = 1
  currentPagePerfis = 1
  fieldsPermissoes: TableField[] = fieldsPermissoes
  fieldsPerfis: TableField[] = fieldsPerfis
  itemsPermissoes: Permissao[] = []
  itemsPerfis: Perfil[] = []
  tableBusy = false
  novaPermissao: Permissao = new Permissao()
  novoPerfil: Perfil = new Perfil()
  permissaoEditar: Permissao = new Permissao()
  perfilEditar: Perfil = new Perfil()
  perfis: any[] = []
  filterPerfis = ""
  filterPerfisOn = ["Sigla", "Descricao"]
  filterPermissoes = ""
  filterPermissoesOn = ["Caminho", "Rota"]

  async mounted() {
    try {
      store.blockScreen = true
      await this.buscarPerfis()
      await this.buscarPermissoes()
      await this.carregarPerfis()

    } finally {
      store.blockScreen = false
    }
  }

  async carregarPerfis(): Promise<void> {
    try {
      const response = await permissoesService.buscarPerfis();
      
      if (response && response.status === 200) {
        this.perfis = response.data.map(p => {
          const retorno = {
            value: p.Id,
            text: `${p.Descricao} (${p.Sigla})`
          }
          return retorno
        })
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao carregar perfis.')
      }
    } catch (e: any) {
      console.error(e)
      this.perfis = []
      this.$toast.error(e.message ? e.message : e);
    }
  }

  async buscarPermissoes(): Promise<void> {
    this.tableBusy = true
    try {
      const response = await permissoesService.buscarPermissoes();
      if (response && response.status === 200) {
        this.itemsPermissoes = response.data.map((p: any) => {
          const retorno = Object.assign(new Permissao(), p)
          retorno.ApenasUg = retorno.ApenasUg == true ? 'Sim' : 'Não'
          retorno.Caminho = retorno.Caminho == null ? '-' : retorno.Caminho
          retorno.Rota = retorno.Rota == null ? '-' : retorno.Rota
          return retorno
        })
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao realizar a consulta.')
      }
    } catch (e: any) {
      console.error(e)
      this.itemsPermissoes = []
      this.$toast.error(e.message ? e.message : e);
    } finally {
      this.tableBusy = false
    }
  }

  async buscarPerfis(): Promise<void> {
    this.tableBusy = true
    try {
      const response = await perfisService.buscarPerfisRaw();
      
      if (response && response.status === 200) {
        this.itemsPerfis = response.data.map((p: any) => {
          const retorno = Object.assign(new Perfil(), p)
          retorno.Oculto = retorno.Oculto == 'S' ? 'Sim' : 'Não'
          retorno.ControleInterno = retorno.ControleInterno == 'S' ? 'Sim' : 'Não'
          return retorno
        })
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao realizar a consulta.')
      }
    } catch (e: any) {
      console.error(e)
      this.itemsPermissoes = []
      this.$toast.error(e.message ? e.message : e);
    } finally {
      this.tableBusy = false
    }
  }
  async removerPerfil(id: number): Promise<void> {
    try {
      store.blockScreen = true
      const resp = await perfisService.removerPerfil(id)
      if (resp && resp.status === 204) {
        this.buscarPerfis()
        this.$toast.success("Perfil excluído com sucesso")
      } else {
        console.error('Erro ao remover permissão', resp)
        this.$toast.error(resp.data.msg || 'Erro ao remover perfil')
      }
    } catch (e: any) {
      console.error('Erro ao remover perfil', e)
      this.$toast.error(e.message || 'Erro ao remover perfil')
    } finally {
      store.blockScreen = false
    }
  }
  async removerPermissao(id: number): Promise<void> {
    try {
      store.blockScreen = true
      const resp = await permissoesService.removerPermissao(id)
      if (resp && resp.status === 204) {
        this.buscarPermissoes()
        this.$toast.success("Permissão excluída com sucesso")
      } else {
        console.error('Erro ao remover permissão', resp)
        this.$toast.error(resp.data.msg || 'Erro ao remover permissão')
      }
    } catch (e: any) {
      console.error('Erro ao remover permissão', e)
      this.$toast.error(e.message || 'Erro ao remover permissão')
    } finally {
      store.blockScreen = false
    }
  }
  async abrirModalAdicionarPermissao(): Promise<void> {
      this.$bvModal.show('add-permissao-modal')
  }
  async fecharModalAdicionarPermissao() {
    this.novaPermissao = new Permissao()
    this.$bvModal.hide('add-permissao-modal')
  }
  async abrirModalAdicionarPerfil(): Promise<void> {
      this.$bvModal.show('add-perfil-modal')
  }
  async fecharModalAdicionarPerfil() {
    this.novoPerfil = new Perfil()
    this.$bvModal.hide('add-perfil-modal')
  }
  async abrirModalEdicaoPermissao(id: number): Promise<void> {
    try {
      const response = await permissoesService.buscarPermissao(id)
      if (response && response.status === 200) {
        this.permissaoEditar = Object.assign(new Permissao(), response.data)
        this.$bvModal.show('edit-permissao-modal')
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao carregar dados da permissão.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }

  }
  async fecharModalEdicaoPerfil() {
    this.perfilEditar = new Perfil()
    this.$bvModal.hide('edit-perfil-modal')
  }
  async abrirModalEdicaoPerfil(id: number): Promise<void> {
    try {
      const response = await perfisService.buscarPerfil(id)
      if (response && response.status === 200) {
        this.perfilEditar = Object.assign(new Perfil(), response.data)
        this.$bvModal.show('edit-perfil-modal')
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao carregar dados do perfil.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }

  }
  async fecharModalEdicaoPermissao() {
    this.permissaoEditar = new Permissao()
    this.$bvModal.hide('edit-permissao-modal')
  }
  async adicionarPermissao() {
    try {
      const response = await permissoesService.adicionarPermissao(this.novaPermissao)
      if (response && response.status === 200) {
        this.novaPermissao = new Permissao()
        this.$bvModal.hide('add-permissao-modal')
        await this.buscarPermissoes()
        this.$toast.success('Permissão salva com sucesso.')
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao salvar permissão.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }
  }
  async editarPermissao() {
    try {
      const response = await permissoesService.editarPermissao(this.permissaoEditar)
      if (response && response.status === 200) {
        this.permissaoEditar = new Permissao()
        this.$bvModal.hide('edit-permissao-modal')
        await this.buscarPermissoes()
        this.$toast.success('Alterações salvas com sucesso.')
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao editar permissão.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }
  }
  async adicionarPerfil() {
    try {
      const response = await perfisService.adicionarPerfil(this.novoPerfil)
      if (response && response.status === 200) {
        this.novoPerfil = new Perfil()
        this.$bvModal.hide('add-perfil-modal')
        await this.buscarPerfis()
        this.$toast.success('Perfil salvo com sucesso.')
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao salvar perfil.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }
  }
  async editarPerfil() {
    try {
      const response = await perfisService.editarPerfil(this.perfilEditar)
      if (response && response.status === 200) {
        this.perfilEditar = new Perfil()
        this.$bvModal.hide('edit-perfil-modal')
        await this.buscarPerfis()
        this.$toast.success('Alterações salvas com sucesso.')
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao editar perfil.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }
  }

  async inativarRota(id: number) {
    try {
      const response = await permissoesService.inativarRota(id)
      if (response && response.status === 200) {
        await this.buscarPermissoes()
        this.$toast.success('Alteração realizada com sucesso.')
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao salvar alteração.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }
  }
};
</script>

<style>
</style>